import * as XLSX from 'xlsx';
import { UpgradeRequest } from '../types/upgrade';
import toast from 'react-hot-toast';

export const exportRoomUpgrades = (
  requests: UpgradeRequest[],
  filters: {
    searchTerm?: string;
    statusFilter?: string;
    organizerFilter?: string;
    hotelFilter?: string;
  } = {}
): boolean => {
  try {
    if (requests.length === 0) {
      toast.error('No data to export');
      return false;
    }

    // Prepare data for export
    const data = requests.map(req => ({
      'Pilgrim Name': req.pilgrimName,
      'Passport Number': req.passportNumber,
      'Hotel': req.fromHotel,
      'From Room Type': req.fromRoomType,
      'To Room Type': req.toRoomType,
      'Status': formatStatus(req.status),
      'Price (SAR)': req.price || '-',
      'Created Date': new Date(req.createdAt).toLocaleDateString(),
      'Guide': req.guideName,
      'Organizer': req.organizerName,
      'Updated Date': new Date(req.updatedAt).toLocaleDateString(),
      'Stay Period': req.startDate && req.endDate 
        ? `${req.startDate} - ${req.endDate}` 
        : 'Not specified'
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(data);

    // Set column widths
    ws['!cols'] = [
      { wch: 30 }, // Pilgrim Name
      { wch: 15 }, // Passport Number
      { wch: 25 }, // Hotel
      { wch: 15 }, // From Room Type
      { wch: 15 }, // To Room Type
      { wch: 15 }, // Status
      { wch: 10 }, // Price
      { wch: 15 }, // Created Date
      { wch: 25 }, // Guide
      { wch: 25 }, // Organizer
      { wch: 15 }, // Updated Date
      { wch: 30 }, // Stay Period
    ];

    // Create workbook and append worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Room Upgrades');

    // Generate filename with current date and filter info
    const date = new Date().toISOString().split('T')[0];
    let filename = `room-upgrades-${date}`;
    
    // Add filter information to filename if present
    if (filters.statusFilter && filters.statusFilter !== 'all') {
      filename += `-${filters.statusFilter}`;
    }
    if (filters.hotelFilter && filters.hotelFilter !== 'all') {
      filename += `-${filters.hotelFilter.replace(/\s+/g, '_')}`;
    }
    
    filename += '.xlsx';

    // Save file
    XLSX.writeFile(wb, filename);
    toast.success('Room upgrades exported successfully');
    return true;
  } catch (error) {
    console.error('Error exporting room upgrades:', error);
    toast.error('Failed to export room upgrades');
    return false;
  }
};

// Helper function to format status for readability
const formatStatus = (status: string): string => {
  switch (status) {
    case 'pending': return 'Pending';
    case 'approved': return 'Approved (Pending Payment)';
    case 'payment_pending': return 'Payment Pending';
    case 'paid': return 'Paid';
    case 'completed': return 'Completed';
    case 'rejected': return 'Rejected';
    case 'cancelled': return 'Cancelled';
    default: return status.charAt(0).toUpperCase() + status.slice(1);
  }
};